import { DateTime } from "luxon";

import type { OrganizationSummaryDto } from "@intelligems/ig-types";

export function isAnOrgSubscriptionActive(orgSummary: OrganizationSummaryDto) {
  return getActiveOrgSubscriptions(orgSummary).length > 0;
}

export function getActiveOrgSubscriptions(orgSummary: OrganizationSummaryDto) {
  return [
    ...orgSummary.stripeSubscriptionSummaries.filter((ss) =>
      ["active", "trialing"].includes(ss.status)
    ),
    ...orgSummary.organizationSubscriptions.filter((os) =>
      ["active", "trialing"].includes(os.status)
    ),
  ];
}

export const getRemainingTrialDays = (orgSummary: OrganizationSummaryDto) => {
  const freeTrial = orgSummary.stripeSubscriptionSummaries.find(
    (ss) => ss.status === "trialing"
  );

  if (!freeTrial) return 0;

  return Math.round(
    DateTime.fromSeconds(freeTrial.periodEnd).diffNow("days").days
  );
};

export const getDeprecatedRemainingTrialDays = (
  freeTrialExpiresAtTs: number | null | undefined,
  createdAtTs: number
) => {
  if (freeTrialExpiresAtTs) {
    const remainingDays = Math.floor(
      (freeTrialExpiresAtTs - DateTime.now().toMillis()) / (60 * 60 * 24 * 1000)
    );
    if (remainingDays <= 0) return 0;
    return remainingDays;
  }
  const daysSinceCreation = Math.floor(
    (DateTime.now().toMillis() - createdAtTs) / (60 * 60 * 24 * 1000)
  );

  return Math.max(0, 7 - daysSinceCreation);
};

export function findClosestGreaterValue(
  target: number,
  obj: Record<string, string[]>
): string[] | null {
  const sortedKeys = Object.keys(obj)
    .map((key) => (key === "inf" ? Infinity : Number(key)))
    .filter((key) => !isNaN(key))
    .sort((a, b) => a - b);

  for (const key of sortedKeys) {
    if (key > target) {
      return obj[key === Infinity ? "inf" : key.toString()];
    }
  }

  return obj["inf"] ?? null;
}
